import { CalendarDays, CalendarOff, CalendarRange, ClipboardList, Users } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

import { useProfessionalAuth } from "../auth/ProfessionalAuthContext";
import { PROFESSIONAL_PERMISSION_KEYS } from "../auth/permissions";
import styles from "./Footer.module.css";

type FooterTab = {
  key: string;
  label: string;
  route: string;
  icon: typeof CalendarDays;
  visible: (permissions: string[]) => boolean;
};

const TABS: FooterTab[] = [
  {
    key: "reservas",
    label: "Reservas",
    route: "/reservas",
    icon: CalendarDays,
    visible: (permissions) => permissions.includes(PROFESSIONAL_PERMISSION_KEYS.RESERVATIONS)
  },
  {
    key: "ausencias",
    label: "Ausencias",
    route: "/ausencias",
    icon: CalendarOff,
    visible: (permissions) => permissions.includes(PROFESSIONAL_PERMISSION_KEYS.LEAVES)
  },
  {
    key: "horario",
    label: "Horario",
    route: "/horario",
    icon: CalendarRange,
    visible: (permissions) => permissions.includes(PROFESSIONAL_PERMISSION_KEYS.SCHEDULE)
  },
  {
    key: "tareas",
    label: "Tareas",
    route: "/tareas",
    icon: ClipboardList,
    visible: (permissions) => permissions.includes(PROFESSIONAL_PERMISSION_KEYS.SCHEDULE)
  },
  {
    key: "clientes",
    label: "Clientes",
    route: "/clientes",
    icon: Users,
    visible: (permissions) =>
      permissions.includes(PROFESSIONAL_PERMISSION_KEYS.CLIENTS) ||
      permissions.includes(PROFESSIONAL_PERMISSION_KEYS.CLIENT_HISTORY)
  }
];

export default function Footer() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { permissions } = useProfessionalAuth();

  const visibleTabs = TABS.filter((tab) => tab.visible(permissions));
  if (visibleTabs.length === 0) {
    return null;
  }

  return (
    <div className={styles.footerWrapper}>
      <footer
        className={styles.footer}
        style={{ gridTemplateColumns: `repeat(${visibleTabs.length}, minmax(0, 1fr))` }}
      >
        {visibleTabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = pathname === tab.route;

          return (
            <button
              key={tab.key}
              type="button"
              className={`${styles.tab} ${isActive ? styles.active : ""}`}
              onClick={() => navigate(tab.route)}
            >
              <span className={styles.iconWrap}>
                <Icon size={20} strokeWidth={2.1} />
              </span>
              <span>{tab.label}</span>
            </button>
          );
        })}
      </footer>
    </div>
  );
}
